import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import store from '@/store';
import { getToken } from '@/utils/auth';

// create an axios instance
var service = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api/' : process.env.VUE_APP_BASE_API,
  // api 的 base_url
  timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  // Do something before request is sent
  if (store.getters.token) {
    // 让每个请求携带token-- ['X-Hk-Admin-Token']为自定义key 请根据实际情况自行修改
    config.headers['X-Hk-Admin-Token'] = getToken();
  }
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(function (response) {
  var res = response.data;
  var status = response.status;
  if (status === 401) {
    MessageBox.alert('系统未登录，请重新登录', '错误', {
      confirmButtonText: '确定',
      type: 'error'
    }).then(function () {
      store.dispatch('FedLogOut').then(function () {
        location.reload();
      });
    });
    return Promise.reject(response);
  } else if (status === 400) {
    MessageBox.alert(res.msg, '错误', {
      confirmButtonText: '确定',
      type: 'error'
    });
    return Promise.reject(response);
  } else {
    console.log('这是啥');
    return response;
  }
}, function (error) {
  // console.log('err' + error) // for debug
  var response = error.response;
  var res = error.response.data;
  var status = error.response.status;
  if (status === 401) {
    MessageBox.alert('系统未登录，请重新登录', '错误', {
      confirmButtonText: '确定',
      type: 'error'
    }).then(function () {
      store.dispatch('FedLogOut').then(function () {
        location.reload();
      });
    });
    return Promise.reject(response);
  } else if (status === 400) {
    MessageBox.alert(res.msg, '错误', {
      confirmButtonText: '确定',
      type: 'error'
    });
    return Promise.reject(response);
  } else {
    Message({
      message: '登录连接超时（后台不能连接，请联系系统管理员）',
      type: 'error',
      duration: 5 * 1000
    });
    return Promise.reject(response);
  }
});
export default service;